var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6363 16.1051C21.6006 12.2791 24.8787 10.4178 25.0286 10.3311C23.1721 7.71601 20.2946 7.3587 19.2834 7.33021C16.8666 7.08448 14.5223 8.7274 13.2912 8.7274C12.0355 8.7274 10.1396 7.35395 8.09633 7.39431C5.46696 7.43348 3.00725 8.90427 1.65806 11.1882C-1.12602 15.8451 0.950344 22.6886 3.61791 26.4528C4.95215 28.2976 6.51144 30.3548 8.55217 30.2824C10.5488 30.204 11.2946 29.0537 13.704 29.0537C16.0912 29.0537 16.7917 30.2824 18.873 30.2361C21.0159 30.204 22.3649 28.3842 23.6526 26.5241C25.1946 24.4123 25.8138 22.3301 25.8384 22.2233C25.7892 22.2067 21.678 20.6896 21.6363 16.1051ZM17.7045 4.85396C18.7782 3.55649 19.5131 1.7913 19.3091 0C17.7548 0.0664764 15.8111 1.03869 14.6917 2.30768C13.7014 3.42591 12.8167 5.25876 13.0452 6.98239C14.7913 7.10822 16.5839 6.13126 17.7045 4.85396Z",
    fill: "#FDFDFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleStore);
export default __webpack_public_path__ + "static/media/apple_store.a9b3d81d25d39f4b60ba11d9409eca8f.svg";
export { ForwardRef as ReactComponent };